import { Component, OnInit, OnChanges, ChangeDetectorRef } from '@angular/core';
import * as firebase from 'firebase/app';
import { AppComponent } from '../app.component';
import { CommonService } from '../service/common.service';
import { StripeService, StripeCardComponent } from 'ngx-stripe';
import {
  StripeElementsOptions
} from '@stripe/stripe-js';
import { FirebaseApiService } from '../service/firebase-api.service';
import { UserProfileService } from '../service/user-profile.service';
import { UserProfile } from '../model/userProfile.model';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css',
    '../../../node_modules/primeflex/primeflex.css',]
})
export class HomeComponent implements OnInit, OnChanges {

  currentUser: firebase.User;
  user: UserProfile = new UserProfile();
  isLoggedin: boolean;

  loading1: boolean;
  loading2: boolean;
  balance: number;

  elementsOptions: StripeElementsOptions = {
    locale: 'en'
  };
  payButtonEnabled = true;
  paySuccessed = false;

  constructor(
    public app: AppComponent,
    private userProfileService: UserProfileService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.getLoggedin();
  }

  ngOnChanges() {
    this.getLoggedin();
  }

  getLoggedin() {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.currentUser) {
      this.isLoggedin = true;

      this.userProfileService.getUserProfileSubscrible(this.currentUser.uid)
        .subscribe((userProfile) => {
          this.user = { ...userProfile };
        })

    } else {
      this.isLoggedin = false;
    }
  }

  updateUserProfile(rowData) {
    this.userProfileService.updateUserProfile(rowData, this.currentUser.uid)
      .then(() => {
        this.messageService.add({ key: 'info', severity: 'success', summary: 'Success', detail: 'Your profile is updated.' });
      })
      .catch((error) => {
        this.messageService.add({ key: 'info', severity: 'error', summary: 'Error', detail: error.message });
      });
  }

}
